export default __webpack_public_path__ + "de71abfafffe7aab358af6ce5de1eb21.png";